import React, { useState, useEffect, useCallback } from 'react';
import Loader from '../manageAccount/accountLoader';
import { apiUrl, secret_key } from '../common/constants';
import { GetRequest, getPassengerGender, getPassengerType, getparamsString, getIPAddress, PostRequest } from '../common/helper';
import { renderImg } from '../common/icons/img';
import Checkbox from '../common/input/checkbox';
import Alert from '../common/alert';
import Confirmation from '../common/confirmation';
import AlertSuccess from '../common/alertSuccess';
import AlertFail from '../common/alertFail';
import moment from 'moment/moment';
import CancelRequestForm from '../common/cancelRequestForm';
import GInput from '../common/input/ginput';
import CaptchaV3 from '../common/recaptchav3';

const CancelDetails = (props) => {

    const [loader, setLoader] = useState(false)
    const [confirmation, setConfirmation] = useState(false);
    const [refund, setShowRefundDetail] = useState(false);
    const [bookingData, setBookingData] = useState(false);
    const params = new URLSearchParams(location.search);
    const [PaxDetail, setPaxDetail] = useState([]);
    const [errorMsg, setErrorMsg] = useState("");
    const [ipAddress, setIPAddress] = useState("");
    const [selectedCount, setSelectedCount] = useState(0);
    const [cancelSuccess, setCancelSuccess] = useState(false);
    const [cancelFail, setCancelFail] = useState(false);
    const [cancelRequest, setCancelRequest] = useState(false);
    const [cancelRequestSucess, setCancelRequestSuccess] = useState(false);
    const [cancelRequestFail, setCancelRequestFail] = useState(false);
    const [remark, setRemark] = useState("");
    const [cancelRequestMsg, setCancelRequestMsg] = useState("");
    const [token, setToken] = useState("");
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const [roundTripMsg, setRoundTripMsg] = useState("");
    const [showRoundTripCancelConfirm, setShowRoundTripCancelConfirm] = useState(true);
    const [isNotCancellable, setNotCancellable] = useState(false);
    const [isServiceCancel, setIsServiceCancel] = useState(false);
    const [totalSeats, setTotalSeats] = useState(0);

    const pnr = props.pnr;//'J659';//'J660';//'J659';//props.pnr
    const mobile = props.mobile;
    const guestCancel = props.guestCancel;

    useEffect(() => {
        if (pnr && mobile) {
            setLoader(true);
            const data = {
                PNR: pnr,
                mobile: mobile,
            };

            const url = apiUrl.packageBookingInfo + "?" + getparamsString(data);

            GetRequest(url)
                .then((res) => {
                    setLoader(false);
                    if (res.Status && !res.Error) {

                        let bookingInfo = res.BookingInfo;

                        setBookingData(
                            bookingInfo
                        );

                        /* if (res.BookingInfo.APIGetBookingDetailsResult[0].IsCancelReqApplicable == 1) {
                            setCancelRequest(true);
                        }

                        if (res.BookingInfo.APIGetBookingDetailsResult[0].IsServiceCancel == '1') {
                            setIsServiceCancel(true);
                        } */
                    } else {
                        if (res.Error) {
                            setErrorMsg(res.Error)
                        }
                    }
                })
                .catch((err) => {
                    setLoader(false);
                    console.log(err);
                });
        }
    }, []);

    useEffect(() => {

        if (bookingData) {

            let paxDetails = [];

            bookingData.map((el) =>
                paxDetails.push({
                    PaxName: el.Name,
                    SeatNo: el.SeatNumber,
                    Age: el.Age,
                    Gender: el.Sex,
                    GST: el.gst,
                })
            )

            setPaxDetail(paxDetails);
            setTotalSeats(paxDetails.length);
        }

        /*  if (bookingData.PaxDetail) {
             setPaxDetail([...bookingData.PaxDetail]);
             setTotalSeats(bookingData?.PaxDetail.length);
         } */

    }, [bookingData]);

    const goBack = () => {
        window.history.back();
    };

    useEffect(() => {
        getIPAddress()
            .then((ip) => {
                setIPAddress(ip);
            })
            .catch((error) => {
                // Handle error
                console.error("Error:", error);
            });
    }, []);


    const handleCheckboxToggle = (index) => {
        const updatedPaxDetail = JSON.parse(JSON.stringify(PaxDetail));
        updatedPaxDetail[index].active = !updatedPaxDetail[index].active;
        setPaxDetail(updatedPaxDetail);
        setShowRefundDetail(false);
    };

    useEffect(() => {
        const selectedCount = PaxDetail.reduce(
            (count, item) => (item.active ? count + 1 : count),
            0
        );
        setSelectedCount(selectedCount);
        setNotCancellable(false);
        /* if (refund) {
            calCulateRefund()
        } */
    }, [PaxDetail]);

    const validateCancel = () => {
        if (selectedCount === 0) {
            // setErrorMsg("Please Select Atleast 1 Passenger to Cancel");
            return false;
        }
        return true;
    };

    const handleConfirm = () => {
        if (validateCancel()) {
            if (refund.result == 'success') {

                const bookingTime = bookingData?.[0]?.BookingDateTime;

                if(bookingTime){

                    const [day, month, yearTime] = bookingTime.split("-");
                    const [year, time] = yearTime.split(" ");
                    const formattedDateStr = `${year}-${month}-${day}T${time}`;
                    const givenDate = new Date(formattedDateStr);
                    const currentTime = new Date();

                    // console.log(givenDate);
                    // console.log(currentTime);

                    // Difference in minutes
                    const diffMs = currentTime - givenDate;
                    const diffMin = Math.floor(diffMs / (1000 * 60));

                    // console.log("Difference in minutes:", diffMin);

                    if(diffMin > 30){

                        if(Number(refund.deduction || 0) > 0 && Number(refund.DeductionPercent || 0) > 0){
                            setConfirmation(true);
                        }else{
                            setErrorMsg("This PNR cannot be cancelled. Please contact KSRTC.");
                        }
                    }else{
                        setConfirmation(true);
                    }
                }

                /* if (bookingData.ReturnBookingStatus === 'B' && showRoundTripCancelConfirm) {
                    setRoundTripMsg("Alert !!! You have already booked return ticket along with this onward ticket, if you want to cancel both onwards ticket and return ticket first cancel return ticket and then onward ticket. For More Info contact at :  7760990034/35.")
                } else { */
                //setConfirmation(true);
                //}
            }
        }
    };

    const cancelTickets = () => {

        setToken("");
        verifyRecaptcha().then((res) => {
            if (res.Success) { } else { return; }
        })
        setRefreshReCaptcha(r => !r);
        setLoader(true);
        setConfirmation(false);
        const selectedSeats = PaxDetail.reduce(
            (list, item) => (item.active ? list.concat(item.SeatNo) : list),
            []
        );

        const data = {
            PNR: bookingData?.[0]?.Pnr,
            SeatNos: selectedSeats.join(","),
            CancelSeatCount: selectedSeats.length,
            RefundAmount: refund.refund,
            CancelCharge: refund.deduction,
            CancelPer: refund.DeductionPercent,
        };

        const url = apiUrl.packageBusSeatsCancellation + "?" + getparamsString(data);

        GetRequest(url)
            .then((res) => {
                setLoader(false);
                const resResult = JSON.parse(res);
                if (resResult[0].result == 'success') {
                    setCancelSuccess(true)
                } else {
                    setCancelFail(true)
                }
            })
            .catch((err) => {
                setLoader(false)
                console.log(err);
            });

    };

    const calCulateRefund = () => {

        if (validateCancel()) {
            setLoader(true);

            const selectedSeats = PaxDetail.reduce(
                (list, item) => (item.active ? list.concat(item.SeatNo) : list),
                []
            );

            const data = {
                PNR: bookingData?.[0]?.Pnr,
                seatNo: selectedSeats.join(","),
            };

            const url = apiUrl.packageBusSeatsCancellationCharges + "?" + getparamsString(data);

            GetRequest(url)
                .then((res) => {
                    setLoader(false);

                    const resResult = JSON.parse(res);
                    if (resResult[0].result === 'success') {
                        setShowRefundDetail(resResult[0])

                    } else {
                        setShowRefundDetail(false);
                        setErrorMsg(resResult[0].result);
                        setNotCancellable(true);
                    }

                })
                .catch((err) => {
                    setLoader(false);
                    console.log(err);
                });
        } else {
            setShowRefundDetail(false);
        }
    }

    /*  const getLevy = (fare) => {
         const {
             BridgeFeeRef = 0,
             EntryFeeRef = 0,
             InfraFeeRef = 0,
             InsuranceFeeeRef = 0,
             TollFeeRef = 0,
             UserFeeRef = 0,
         } = fare;
         return (
             BridgeFeeRef + EntryFeeRef + InfraFeeRef + InsuranceFeeeRef + TollFeeRef + UserFeeRef
         );
     }; */
    /*  const getLevyRefund = (fare) => {
         const {
             IsBridgeFeeRef,
             IsEntryFeeRef,
             IsInfraFeeRef,
             IsInsuranceFeeRef,
             IsTollFeeRef,
             IsUserFeeRef,
         } = fare;
         const {
             FinalBridgeFeeRef = 0,
             FinalEntryFeeRef = 0,
             FinalInfraFeeRef = 0,
             FinalInsuranceFeeRef = 0,
             FinalTollFeeRef = 0,
             FinalUserFeeRef = 0,
         } = fare;
         let levyRefund = 0;
         if (IsBridgeFeeRef) {
             levyRefund += FinalBridgeFeeRef;
         }
         if (IsEntryFeeRef) {
             levyRefund += FinalEntryFeeRef;
         }
         if (IsInfraFeeRef) {
             levyRefund += FinalInfraFeeRef;
         }
         if (IsInsuranceFeeRef) {
             levyRefund += FinalInsuranceFeeRef;
         }
         if (IsTollFeeRef) {
             levyRefund += FinalTollFeeRef;
         }
         if (IsUserFeeRef) {
             levyRefund += FinalUserFeeRef;
         }
         return levyRefund;
     }; */

    /*  const submitCancelRequest = () => {
         if (remark !== "" && remark.length >= 4) {
             let postData = {
                 PNR: bookingData.BookingRefNo,
                 TranPwd: "",
                 MobileNo: bookingData.PassengerContactNo1,
                 RequestTypeID: 1,
                 Remarks: remark,
             };
             setToken("");
             verifyRecaptcha().then((res) => {
                 if (res.Success) { } else { return; }
             })
             setRefreshReCaptcha(r => !r);
             setLoader(true);
             PostRequest(apiUrl.pnrCancelRequest, postData)
                 .then((response) => {
                     if (response.ErrorMessage) {
                         setCancelRequest(false);
                         setCancelRequestFail(true);
                         setCancelRequestMsg(response.ErrorMessage)
                         setLoader(false);
                     } else {
                         setCancelRequest(false);
                         setCancelRequestSuccess(true)
                         setLoader(false);
                     }
                 })
                 .catch((error) => {
                     setLoader(false);
                     console.log(error);
                 });
         } else {
             //setErrorMsg("Please Enter the remark")
         }
     } */


    const onVerify = useCallback((token) => {
        setToken(token);
    });

    const verifyRecaptcha = async () => {
        const data = {
            // secret: secret_key,
            response: token
        };
        setLoader(true)
        return PostRequest(apiUrl.validateCaptcha, data)
            .then((res) => {
                if (res.Success) {
                    setLoader(false);
                } else {
                    setLoader(false);
                    // setErrorMsg('Error verifying reCAPTCHA token');
                }
                return res;
            })
            .catch((err) => {
                setLoader(false);
                // setErrorMsg(`Error verifying reCAPTCHA token: ${err}`);
            });
    };

    return (
        <>
            {loader && <Loader />}
            <div className='pax--container' style={guestCancel ? { background: '#fff', boxShadow: '0 1px 3px 0 rgba(0,0,0,0.15)', borderRadius: '8px' } : {}}>
                <div className="passenger--details" style={guestCancel ? { padding: '0 16px' } : {}}>
                    <div className="head--text dark">Select Passenger to Cancel Seats</div>
                    <div className="passenger--table">
                        <div className="passenger--head">
                            <div>ಆಯ್ಕೆ ಮಾಡಿ / <br /> Select</div>
                            <div>ಹೆಸರು / <br /> Passenger Name</div>
                            <div>ಆಸನ ಸಂಖ್ಯೆ / <br /> Seat No.</div>
                            <div>ವಯಸ್ಸು / <br /> Age</div>
                            <div>ವಯಸ್ಕರು / ಮಕ್ಕಳು / <br /> Adult / Child</div>
                            <div>ಲಿಂಗ / <br /> Gender</div>
                            {/* <div>ರಿಯಾಯಿತಿ  ವಿಧ /<br /> Concession Type</div> */}
                        </div>
                        {PaxDetail.map((data, index) => (
                            <div className="passenger--row" key={`pass_${index}`}>
                                <div>
                                    <Checkbox
                                        onClick={() =>
                                            handleCheckboxToggle(
                                                index
                                            )
                                        }
                                        active={data?.active}
                                    />
                                </div>
                                <div>{data.PaxName}</div>
                                <div>{data.SeatNo}</div>
                                <div>{data.Age}</div>
                                <div>{getPassengerType(data.Age)}</div>
                                <div>{getPassengerGender(data.Gender)}</div>
                                {/* <div>{data.ConcessionTypeName}</div> */}
                            </div>
                        ))}
                    </div>
                    <div className={`canc_btn_wrap`}>
                        <div className={`canc_btn ${(refund || selectedCount === 0) ? 'disabled' : ''}`}
                            onClick={() =>
                                !refund && calCulateRefund()
                            }>
                            show refund details
                        </div>
                        <div className='can_imp_text'>
                            <div style={{ marginRight: '8px' }}>{renderImg('ex_icon')}</div>
                            <div>ಗಮನಿಸಿ: ಮರುಪಾವತಿ ವಿವರಗಳನ್ನು ಪ್ರದರ್ಶಿಸಲಾಗುವುದಿಲ್ಲ,ಆಯ್ಕೆಮಾಡಿದ ಟಿಕೆಟ್ ರದ್ದತಿ ನಿಯಮಗಳ ಅಡಿಯಲ್ಲಿ ಬರುವುದಿಲ್ಲ. <br />
                                Note: Refund details are not displayed, if the selected ticket is does not fall under the cancellation terms.</div>
                        </div>
                    </div>
                    {refund && selectedCount > 0 &&
                        <div className="fare--table" style={{ paddingTop: '20px' }}>
                            <div className="fare--head">
                                <div>ವಿವರಣೆ / <br /> Description</div>
                                <div>ಮೂಲ ವಹಿವಾಟು (₹) / <br /> Original Transaction (₹)</div>
                                <div>ಮರುಪಾವತಿಸಲು (₹) / <br /> To Be Refunded (₹)</div>
                                <div>ರದ್ದತಿ ಶೇಕಡಾವಾರು (%) / <br /> Cancellation Percentage (%)</div>
                            </div>

                            {/*  <div className="fare--row">
                                <div>ಪ್ರಯಾಣ ದರ / Journey Fare</div>
                                <div>₹{refund?.TotalFare}</div>
                                <div>₹{parseInt(refund?.FinalFareWithCan)}</div>
                                <div>{refund.ChargePCT}%</div>
                            </div>

                            <div className="fare--row">
                                <div>ಮೀಸಲಾತಿ ಶುಲ್ಕ / Reservation Fee</div>
                                <div>₹{refund?.SRTFeeRef}</div>
                                <div>₹{refund.IsSRTFeeRef === 1 ? refund?.FinalSRTFeeRef : 0}</div>
                                <div>{"-"}</div>
                            </div>

                            <div className="fare--row">
                                <div>ಇತರೆ ಲೆವಿಗಳು / Other Levies</div>
                                <div>₹{getLevy(refund)}</div>
                                <div>₹{getLevyRefund(refund)}</div>
                                <div>{"-"}</div>
                            </div>

                            <div className="fare--row">
                                <div>ಜಿಎಸ್ಟಿ / GST</div>
                                <div>₹{refund.GstRef}</div>
                                <div>₹{refund.IsGSTRef === 1 ? refund.FinalGST : 0}</div>
                                <div>{"-"}</div>
                            </div>
                            <div className="fare--row">
                                <div>ಕಡಿಮೆ ರಿಯಾಯಿತಿ / Less Discount</div>
                                <div>₹{refund.ConcessionAmount + refund.Discount}</div>
                                <div>₹{refund.FinalConcessionRef}</div>
                                <div>{"-"}</div>
                            </div>
                            <div className="fare--row">
                                <div>ಪಾವತಿ ಗೇಟ್‌ವೇ ಶುಲ್ಕಗಳು / Payment Gateway Charges</div>
                                <div>₹{refund.KSRTCPGCharge}</div>
                                <div>₹0</div>
                                <div>{"-"}</div>
                            </div> */}
                            <div className="fare--row">
                                <div>ಒಟ್ಟು / Total</div>
                                <div>₹{refund.totalFare}</div>
                                <div>₹{refund.refund}</div>
                                <div>{refund.DeductionPercent}</div>
                            </div>
                        </div>
                    }
                    <div className='ipAddress'>
                        ನಿಮ್ಮ IP ವಿಳಾಸ: {ipAddress} / Your IP Address: {ipAddress}
                    </div>
                </div>
                <div className={`cancel--button ${(selectedCount === 0 || (refund?.result != 'success') || isNotCancellable || (isServiceCancel && totalSeats != selectedCount)) ? 'disable' : ''}`}
                    onClick={handleConfirm}
                >
                    cancel ticket
                </div>
            </div>
            {confirmation && (
                <Confirmation
                    msg={
                        <div
                            className="tnc-block-text"
                            style={{ justifyContent: "center" }}
                        >
                            <div className="icon">
                                {renderImg('close_icon')}
                            </div>
                            <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020', padding: '16px 0' }}>
                                {selectedCount === PaxDetail?.length
                                    ? `Are you sure you want to cancel All Passengers?`
                                    : `Are you sure you want to cancel ${selectedCount} Passengers? A
                                new PNR shall be issued for remaining
                                passengers, if any.`}
                            </div>
                        </div>
                    }
                    noAction={() => setConfirmation(false)}
                    yesAction={cancelTickets}
                />
            )}
            {errorMsg && <Alert msg={errorMsg} close={() => setErrorMsg("")} />}
            {cancelSuccess && <AlertSuccess
                msg={
                    <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                    >
                        <div className="icon">
                            {renderImg('success_icon')}
                        </div>
                        <div style={{ color: '#3C763C', fontSize: '20px', fontWeight: '500', lineHeight: '28px', textAlign: 'center', padding: '16px 0' }}>Booking Cancelled</div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                            Ticket booked on  {moment(bookingData?.[0]?.BookingDateTime, 'DD-MM-YYYY HH:mm:ss').format('HH:mm, ddd DD MMM')} has been cancelled and mailed to {bookingData?.[0]?.EMail} and a SMS has been sent to {bookingData?.[0]?.EmergencyContactInfo}
                        </div>
                    </div>
                }
            />}
            {cancelFail && <AlertFail
                msg={
                    <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                    >
                        <div className="icon">
                            {renderImg('fail_icon')}
                        </div>
                        <div style={{ color: '#F05924', fontSize: '20px', fontWeight: '500', lineHeight: '28px', textAlign: 'center', padding: '16px 0' }}>Cancellation Failed</div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                            This ticket is no longer cancellable as per the cancellation policy at the
                            time of booking.
                        </div>
                    </div>
                }
            />}

            {
                /* cancelRequest &&

                <CancelRequestForm

                    msg={
                        < div
                            className="tnc-block-text"
                            style={{ justifyContent: "center" }}
                        >
                            <GInput
                                type="tel"
                                value={"Cancellation Request"}
                                disabled={true}
                                readonly={true}
                                label="Request Type"
                                validation="mobile"
                            // icon={renderImg("txn_pwd")}
                            />
                            <GInput
                                type="text"
                                value={remark}
                                errMsg="Enter the valid remark"
                                validation="cancel_remark"
                                onChange={(e) => setRemark(e)}
                                label="Remarks"
                                key={"remarks"}
                            />
                            <div className="cancel--request--btn" onClick={submitCancelRequest}>Submit Request</div>
                        </div>
                    }
                    onClick={setCancelRequest}
                /> */
            }

            {/* 
                cancelRequestSucess &&
                <AlertSuccess
                    msg={
                        <div
                            className="tnc-block-text"
                            style={{ justifyContent: "center" }}
                        >
                            <div className="icon">
                                {renderImg('success_icon')}
                            </div>

                            <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                                We have received your Cancellation Request after journey date. We shall review and mail you back on the same.
                            </div>
                        </div>
                    }
                />
             */}
            {/* cancelRequestFail &&

                <AlertFail
                    msg={
                        <div
                            className="tnc-block-text"
                            style={{ justifyContent: "center" }}
                        >
                            <div className="icon">
                                {renderImg('login_error')}
                            </div>
                            <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                                {cancelRequestMsg || 'You have already raised a cancellation request for this PNR which is under process at KSRTC end.'}
                            </div>
                        </div>
                    }

                /> */}

            {
                /* roundTripMsg && showRoundTripCancelConfirm &&
                <AlertFail
                    msg={
                        <div
                            className="tnc-block-text"
                            style={{ justifyContent: "center" }}
                        >
                            <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                                {roundTripMsg}
                            </div>
                        </div>
                    }
                    btnText="OK"
                    onClose={() => {
                        setRoundTripMsg(false);
                        setShowRoundTripCancelConfirm(false);
                    }}

                /> */
            }

            <CaptchaV3
                onVerify={onVerify}
                token={token}
                refreshReCaptcha={refreshReCaptcha}
            />


        </>
    )
}

export default CancelDetails;